import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TextField from "@material-ui/core/TextField";
import { getPriceLists } from "../../../actions/priceListActions";
import NoItems from "../../HelperComponents/NoItems/NoItems";
import CheckboxHelper from "../CheckboxHelper/CheckboxHelper";
import PricesIcon from "../../../assets/image/no_prices.png";
import "./PriceListLocationPicker.scss";

class PriceListLocationPicker extends Component {
  state = {
    open: [],
    checkboxObj: {},
    location: "",
  };

  componentDidMount() {
    const { getPriceLists } = this.props;
    getPriceLists().then((res) => {
      if (res.payload && res.payload.status === 200) {
        this.initCheckboxObj();
      }
    });
  }

  initCheckboxObj = () => {
    const { price_list: { price_lists } } = this.props;
    const { checkboxObj } = this.state;

    price_lists.forEach((elParent) => {
      if (elParent.price_list.length !== 0) {
        elParent.price_list.forEach((elChild) => {
          if (elChild.superadmin_mark) {
            if (!checkboxObj[elParent.id]) {
              checkboxObj[elParent.id] = [];
            }
          }
        });
      }
    });

    this.setState({ checkboxObj });
  };

  emitChange = () => {
    const { onChange } = this.props;
    const { location, checkboxObj, open } = this.state;
    const priceListId =
      open[0] && checkboxObj[open[0]] ? checkboxObj[open[0]][0] || null : null;
    if (onChange) onChange({ location, priceListId });
  };

  toggleCheck = (id) => {
    const { checkboxObj } = this.state;
    if (!checkboxObj[id]) {
      checkboxObj[id] = [];
    }
    if (checkboxObj[id].length === 0) {
      checkboxObj[id] = [];
    } else {
      delete checkboxObj[id];
    }
    this.setState({ checkboxObj }, this.emitChange);
  };

  toggleChildChange = (parentId, childId) => {
    const { checkboxObj } = this.state;
    if (!checkboxObj[parentId]) {
      checkboxObj[parentId] = [];
    }
    if (!checkboxObj[parentId].includes(childId)) {
      checkboxObj[parentId] = [childId];
    } else {
      checkboxObj[parentId] = checkboxObj[parentId].filter((el) => el !== childId);
    }
    this.setState({ checkboxObj }, this.emitChange);
  };

  toggleOpen = (id) => {
    const { open } = this.state;
    if (open.includes(id)) {
      this.setState(
        ({ open }) => ({ open: open.filter((el) => el !== id) }),
        this.emitChange
      );
    } else {
      this.setState({ open: [id] }, this.emitChange);
    }
  };

  handleLocationChange = (e) => {
    const location = e.target.value;
    this.setState({ location }, this.emitChange);
  };

  render() {
    const { price_list: { price_lists } } = this.props;
    const { open, checkboxObj, location } = this.state;

    return (
      <div className="price_list_location_picker">
        <TextField
          value={location}
          onChange={this.handleLocationChange}
          label="Место хранения"
          variant="outlined"
          autoComplete="off"
          classes={{ root: "custom_input_wrapper" }}
          InputProps={{
            classes: {
              root: "custom_input",
              focused: "custom_input_focused",
              notchedOutline: "custom_input_outline",
            },
          }}
          InputLabelProps={{
            classes: {
              root: "custom_input_label",
              focused: "custom_input_label_focused",
              shrink: "custom_input_label_active",
            },
          }}
        />

        <div className="scroll_block">
          {price_lists && price_lists.length === 0 ? (
            <NoItems>
              <div className="box-img">
                <img src={PricesIcon} alt="prices icon" />
              </div>
              <div className="title">Пока нет ни одного прайс-листа</div>
            </NoItems>
          ) : (
            price_lists.map(({ company, price_list, id }) =>
              price_list.length !== 0 ? (
                <CheckboxHelper
                  key={id}
                  id={id}
                  price_list={price_list}
                  company={company}
                  toggleOpen={() => this.toggleOpen(id)}
                  open={open}
                  toggleCheck={() => this.toggleCheck(id, price_list)}
                  checkboxObj={checkboxObj}
                  toggleChildChange={this.toggleChildChange}
                  type={"approve"}
                />
              ) : null
            )
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  price_list: state.price_list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getPriceLists }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PriceListLocationPicker);
